// App.js
import React, { useState, useEffect } from "react";
import { Box, VStack } from "@chakra-ui/react";
import { Routes, Route } from "react-router-dom";
import Header from "./Header";
import Home from "./Home";
import Program from "./Program";
import Courses from "./Courses";
import Testimonials from "./Testimonials";
import { Registration } from "./Registration";
import Footer from "./Footer";
import { CourseClassroom } from "./CourseClassroom";
import WhatsAppButton from "./whatsAppButton";
import { OfferPopup } from "./OfferPopup";

function App() {
  const [showOffer, setShowOffer] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowOffer(true);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {showOffer && <OfferPopup onClose={() => setShowOffer(false)} />}
      <Box p={4}>
        <Header />

        <Routes>
          <Route
            path="/"
            element={
              <VStack spacing={{ base: 45, md: 354 }} align="stretch">
                <Home />
                <Program />
                <Testimonials />
                <Courses />
                <Registration />
                <Footer />
              </VStack>
            }
          />
          <Route path="/program" element={<Program />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/registration" element={<Registration />} />
          <Route path="/classroom/:courseId" element={<CourseClassroom />} />
        </Routes>

        <WhatsAppButton />
      </Box>
    </>
  );
}

export default App;
